/**
 * Oturum kaydındaki `ClientInfo` metninden okunur parçalar.
 *
 * Kayıt ham User-Agent'ı da taşıyor ("… · Mozilla/5.0 (…)"); ekranda gösterilecek olan
 * özet kısım. Hem giriş geçmişinde hem "başka yerden giriş yapıldı" uyarısında aynı
 * biçim kullanılıyor: kullanıcı iki yerde aynı cihaz adını görmeli.
 */
export function splitClientInfo(raw: string | null): { device: string; ip: string | null } {
  if (!raw) return { device: '—', ip: null };
  const ipMatch = /IP:\s*([^\s·]+)/i.exec(raw);
  // Ham User-Agent gösterilmez: özet kısım "·" ile ayrılmış parçalarda duruyor.
  const parts = raw
    .split('·')
    .map((p) => p.trim())
    .filter((p) => p && !/^IP:/i.test(p) && !/^Mozilla\//i.test(p));
  // Kullanıcının verdiği cihaz ADI en ayırt edici bilgi; satır kısaldığında ilk o
  // görünmeli. Ad verilmemişse kayıtta yalnız kimlik durur — onu göstermek kimseye bir
  // şey anlatmaz, o durumda işletim sistemi/tarayıcı öne alınır.
  const named = parts
    .map((p) => /^Cihaz:\s*(.+?)\s*\([0-9a-f-]{36}\)\s*$/i.exec(p)?.[1])
    .filter((name): name is string => !!name);
  const rest = parts.filter((p) => !/^Cihaz:/i.test(p));
  return { device: [...named, ...rest].join(' · ') || '—', ip: ipMatch?.[1] ?? null };
}
